import * as Sentry from "@sentry/react";
import { useCallback } from "react";

type LoggerLevels = "error" | "warn" | "debug";

export const useSentryLogger = (level?: LoggerLevels) => {
  return useCallback(
    (message: string, log?: unknown) => {
      if (level === "error") {
        return Sentry.logger.error(message, { log });
      }

      if (level === "warn") {
        return Sentry.logger.warn(message, { log });
      }

      if (level === "debug") {
        return Sentry.logger.debug(message, { log });
      }

      return Sentry.logger.info(message, { log });
    },
    [level]
  );
};
